import { render, staticRenderFns } from "./contractSealDetail.vue?vue&type=template&id=a530a97c&scoped=true"
import script from "./contractSealDetail.vue?vue&type=script&lang=js"
export * from "./contractSealDetail.vue?vue&type=script&lang=js"
import style0 from "./contractSealDetail.vue?vue&type=style&index=0&id=a530a97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530a97c",
  null
  
)

export default component.exports